import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';

// Layouts
import MainLayout from './layouts/MainLayout';
import CheckoutLayout from './layouts/CheckoutLayout.js';

// Website Pages
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage.js';
import CheckoutPage from './pages/CheckoutPage.js';
import SingleProductPage from './pages/SingleProductPage.js';
import ConfirmationPage from './pages/ConfirmationPage.js';

import { CartProvider } from './context/CartContext';

const App = () => (
  <Router>
    <CartProvider>
      <Routes>
        <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
        <Route path="/tienda/:categoryName" element={<MainLayout><ShopPage /></MainLayout>} />
        <Route path="/tienda" element={<MainLayout><ShopPage /></MainLayout>} />
        <Route path="/product/:productUid/:productName" element={<MainLayout><SingleProductPage /></MainLayout>} />
        <Route path="/checkout" element={<CheckoutLayout><CheckoutPage /></CheckoutLayout>} />
        <Route path="/order-confirmation" element={<MainLayout><ConfirmationPage /></MainLayout>} />
      </Routes>
    </CartProvider>
  </Router>
);

export default App;
